import { Box, Tooltip, IconButton } from '@mui/material';
import { ContentCopy, OpenInNew } from '@mui/icons-material';
import * as React from 'react';
import { vehiclePageStyles } from '../styles';
import { useCopyToClipboard } from '../hooks/use_copy_to_clipboard';
import '../styles.css';

interface VehiclePublicLinkSectionProps {
  vehicleId: string;
}

const VehiclePublicLinkSection = ({ vehicleId }: VehiclePublicLinkSectionProps) => {
  const { copyTooltip, copyToClipboard } = useCopyToClipboard();

  const getPublicVehicleUrl = (vehicleId: string) => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/public/vehicles/${vehicleId}`;
  };

  return (
    <Box sx={vehiclePageStyles.card}>
      <Box sx={{ ...vehiclePageStyles.cardHeader, mb: 0 }}>
        Public Link
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <Tooltip title="Open in a new tab">
            <IconButton size="small" onClick={() => window.open(getPublicVehicleUrl(vehicleId), '_blank')}>
              <OpenInNew fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={copyTooltip}>
            <IconButton size="small" onClick={() => copyToClipboard(getPublicVehicleUrl(vehicleId))}>
              <ContentCopy fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default VehiclePublicLinkSection;
